export default __webpack_public_path__ + "static/dd913ac25c432558921325c37af7899c.svg";